import { USER_SESSION_SERVICE_NAME } from "../../../../services/user-session";
import { KingspanInstallationCategoryPopupController } from "./ks-inst-cat-cr-ed-popup.controller";
import { KINGSPAN_CONFIGURATION_FORM_SERVICE_NAME } from "../service";
import { IMRBaseComponent } from "../../../../modules/common/base";

//#region Asset Imports

import "./ks-inst-cat-cr-ed-popup.scss";
import * as TEMPLATE from "./ks-inst-cat-cr-ed-popup.tpl.html";

//#endregion

export class KingspanInstallationCategoryPopupComponent extends IMRBaseComponent {
  constructor() {
    super({
      controller: KingspanInstallationCategoryPopupController,
      services: [
        USER_SESSION_SERVICE_NAME,
        KINGSPAN_CONFIGURATION_FORM_SERVICE_NAME,
      ],
      template: TEMPLATE,
    });
  }
}
